import { assign } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';

export const addToCartSuccess = assign(
  (
    context: ProductBuilderMachineContext,
    event: ProductBuilderMachineEvent,
  ) => {
    const { cart } = context;
    if (
      event.type !== 'done.invoke.productBuilder.complete.loading:invocation[0]'
    )
      return context;
    console.log('Add to cart succeeded');
    const existingItems = cart && cart.items ? cart.items : [];
    const newItems = event.data.items ? event.data.items : [];
    window.location.href = '/cart';
    return {
      cart: {
        ...(cart ? cart : {}),
        ...event.data,
        items: existingItems.concat(newItems),
      },
    };
  },
);
